import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/database";

import firebaseConfig from "./firebaseConfig";

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage(),
  database = firebase.database();

export default firebase;

export { storage, database };
